import { makeStyles } from '@material-ui/core'

import { getFont, lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  channelsRow: {
    display: 'grid',
    gridTemplateColumns: '5.42fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    borderTop: '1px solid #e7e7e7',
    backgroundColor: theme.palette.grey[200]
  },
  channelsRowForMonth: {
    gridTemplateColumns: '9fr repeat(31,1fr)',
    [theme.breakpoints.down(1460)]: {
      gridTemplateColumns: '10fr repeat(31,1fr)'
    }
  },
  channelsRowContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  channelsRowIcon: {
    width: '100%'
  },
  rowNameTitle: {
    flex: 1,
    marginLeft: 3,
    fontSize: 12
  },
  channelsRowName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15,
    justifyContent: 'space-between'
  },
  channelsRowNameMarginLeft: {
    marginLeft: 2,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15,
    justifyContent: 'space-between'
  },
  numberOfRoomType: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  roomTypeLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`,
    cursor: 'pointer'
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  textAndIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  status: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  normalStatus: {
    background: theme.palette.success.main
  },
  warningStatus: {
    background: theme.palette.warning.main
  },
  criticalStatus: {
    background: theme.palette.error.main
  },
  unexpectedStatus: {
    background: theme.palette.info.main
  },
  textTimeTwoWeeks: {
    fontSize: 12,
    color: theme.palette.primary.contrastText
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.grey[700]}`,
    borderRadius: 4
  },
  textTimeMonth: {
    fontSize: 9,
    color: theme.palette.primary.contrastText
  },
  dayContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
export default useStyles
